import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f598df5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "meet-us-at" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" Meet Us At "),
    /*#__PURE__*/_createElementVNode("span", { class: "color" }, "Ice London 2023")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, " Book an appointment to save your precious time! ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "logo" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "color" }, [
    /*#__PURE__*/_createTextVNode(" STAND NO. S5-340"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createTextVNode(" 7-9 February, 2023"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ExCeL London, UK ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "btn",
  href: `https://www.icelondon.uk.com/exhibitors/aardvark-technologies?&azletter=A
                &searchgroup=libraryentry-exhibitors`,
  target: "_blank"
}, " Check More ", -1))
const _hoisted_12 = ["src"]
const _hoisted_13 = ["action"]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<input type=\"hidden\" name=\"_subject\" value=\"Book an appointment from ADV.BET\" data-v-0f598df5><h3 data-v-0f598df5> Book an <span class=\"color\" data-v-0f598df5>appointment</span></h3><div class=\"input-holder\" data-v-0f598df5><label for=\"company\" data-v-0f598df5>Company Name</label><input type=\"text\" name=\"company\" placeholder=\"Company Name\" required data-v-0f598df5></div><div class=\"input-holder\" data-v-0f598df5><label for=\"fname\" data-v-0f598df5>First Name <span class=\"required\" data-v-0f598df5>*</span></label><input type=\"text\" name=\"fname\" placeholder=\"First Name\" required data-v-0f598df5></div><div class=\"input-holder\" data-v-0f598df5><label for=\"lname\" data-v-0f598df5>Last Name <span class=\"required\" data-v-0f598df5>*</span></label><input type=\"text\" name=\"lname\" placeholder=\"Last Name\" required data-v-0f598df5></div><div class=\"input-holder\" data-v-0f598df5><label for=\"email\" data-v-0f598df5>Email <span class=\"required\" data-v-0f598df5>*</span></label><input type=\"email\" name=\"email\" placeholder=\"Email\" required data-v-0f598df5></div>", 6)
const _hoisted_20 = {
  class: "btn",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FAIcon = _resolveComponent("FAIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              class: "ice-logo",
              src: require('@/assets/img/exhibitions/IceLondon.png')
            }, null, 8, _hoisted_8),
            _hoisted_9,
            _hoisted_10,
            _hoisted_11
          ]),
          _createElementVNode("img", {
            class: "meet-us-img",
            src: require('@/assets/img/exhibitions/ice_london.png')
          }, null, 8, _hoisted_12)
        ]),
        _createElementVNode("form", {
          class: "appointment-form",
          action: `https://formsubmit.co/${_ctx.email}`,
          method: "POST"
        }, [
          _hoisted_14,
          _createElementVNode("button", _hoisted_20, [
            _createVNode(_component_FAIcon, {
              icon: "paper-plane",
              class: "ico"
            }),
            _createTextVNode("BOOK AN APPOINTMENT ")
          ])
        ], 8, _hoisted_13)
      ])
    ])
  ]))
}